module.exports = __webpack_public_path__ + "img/Large-Horizontal-Rectangular-Attachment-31.4d9bf5ea.png";